const ID_TOKEN_KEY = "access_token";
const ADMIN_ID = "Admin_id";

export const getAdminId = () => {
    return window.localStorage.getItem(ADMIN_ID)
};

export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const AuthorizationHeader = {
    Authorization: 'Bearer '+ getToken(),
    'admin-id': getAdminId()
}

export default { getToken, saveToken, destroyToken, getAdminId, AuthorizationHeader };
